import Vue from 'vue';
export default Vue.extend({
    props: {
        size: { type: Number, default: 24 },
        color: { type: String, default: '' },
        name: { type: String, required: true },
        hoverMessage: { type: String, default: '' },
    },
    data() {
        return {
            icons: {
                'share': require('assets/icons/share.svg'),
                'edit': require('assets/icons/edit.svg'),
                'edit-filled': require('assets/icons/edit-filled.svg'),
                'trash': require('assets/icons/trash.svg'),
                'revert': require('assets/icons/revert.svg'),
                'calendar': require('assets/icons/calendar.svg'),
                'calendar-filled': require('assets/icons/calendar-filled.svg'),
                'chat': require('assets/icons/chat.svg'),
                'chat-filled': require('assets/icons/chat-filled.svg'),
                'envelope': require('assets/icons/envelope.svg'),
                'gear': require('assets/icons/gear.svg'),
                'segment': require('assets/icons/segment.svg'),
                'bar-chart': require('assets/icons/bar-chart.svg'),
                'person-heart': require('assets/icons/person-heart.svg'),
                'hashtag': require('assets/icons/hashtag.svg'),
                'speech': require('assets/icons/speech.svg'),
                'smile': require('assets/icons/smile.svg'),
                'eraser': require('assets/icons/eraser.svg'),
                'plus': require('assets/icons/plus.svg'),
                'info': require('assets/icons/info.svg'),
                'double-chevron-up': require('assets/icons/double-chevron-up.svg'),
                'double-chevron-down': require('assets/icons/double-chevron-down.svg'),
                'chevron-left': require('assets/icons/chevron-left.svg'),
                'chevron-right': require('assets/icons/chevron-right.svg'),
                'tick': require('assets/icons/tick.svg'),
                'horizontal-dots': require('assets/icons/horizontal-dots.svg'),
                'drag-dots': require('assets/icons/drag-dots.svg'),
            }
        };
    },
    created() {
        const iconNames = Object.keys(this.icons);
        if (!iconNames.includes(this.name)) {
            throw new Error(`Icon name "${this.name}" does not exist`);
        }
    },
});
